import { DateTimePicker } from "@mui/x-date-pickers";
import { DateTime } from "luxon";

/** One downtime bound as a DateTimePicker over ISO-string state (local timezone display). */
export function DowntimeBoundPicker({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string | null;
  onChange: (iso: string | null) => void;
}) {
  return (
    <DateTimePicker
      label={label}
      value={value ? DateTime.fromISO(value) : null}
      onChange={(newValue) => onChange(newValue?.toISO() ?? null)}
      slotProps={{ textField: { fullWidth: true } }}
    />
  );
}
